import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../store/hooks";
import { PlanPackagesE } from "../models/enums";
import type { PurchaseParamsT } from "../models/models";
import { selectPlanMaxSubUsersQuantity } from "../store/purchasesSelectors";
import { useUser } from "../../../../contexts/userContext/userContext";
import type { BillingDetailsT } from "../../../../models/models";
import type { RootState } from "../../../../store/store";

/**
 * Custom hook to get the maximum number of sub-users allowed for a given plan.
 *
 * @param plan - The plan package type.
 * @returns The maximum number of sub-users allowed for the given plan.
 */
const usePlanMaxSubUsers = (plan: PlanPackagesE) => {
  const { packageType } = useParams<PurchaseParamsT>();
  const { getUserBillingDetails } = useUser();

  /**
   * The maximum number of sub-users allowed for the current plan.
   *
   * @remarks
   * This value is determined based on the selected plan and package type.
   *
   * @returns The maximum number of sub-users allowed.
   */
  const planMaxSubUsers = useAppSelector((state: RootState) =>
    selectPlanMaxSubUsersQuantity(
      state,
      (Object.keys(PlanPackagesE)?.some((p) => p === plan)
        ? packageType
        : (getUserBillingDetails() as BillingDetailsT)?.type) as PlanPackagesE
    )
  );

  return planMaxSubUsers || 0;
};

export default usePlanMaxSubUsers;
